import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { useAuthStore } from '@/store/auth.store';
import { listMyOrders } from '@/services/client';
import { formatDate, formatRub, statusLabel } from '@/utils/format';

export default function Orders() {
  const token = useAuthStore((s) => s.accessToken);
  const { data, isLoading } = useQuery({
    queryKey: ['client/orders'],
    queryFn: listMyOrders,
    enabled: !!token,
    refetchInterval: 15_000,
  });

  if (!token) {
    return (
      <div className="p-6 text-center">
        <p className="text-sm text-slate-500 mb-3">История заказов доступна после входа.</p>
        <Link className="btn-primary" to="/login">Войти</Link>
      </div>
    );
  }

  return (
    <div className="pt-4">
      <div className="px-4 mb-4">
        <h1 className="text-2xl font-semibold">Мои заказы</h1>
      </div>
      <div className="px-4 space-y-2">
        {isLoading && <div className="text-center text-slate-400">Загрузка…</div>}
        {data?.map((o) => (
          <Link key={o.id} to={`/orders/${o.id}`} className="card p-4 flex justify-between items-start">
            <div>
              <div className="font-semibold">Заказ №{o.number}</div>
              <div className="text-xs text-slate-500 mt-0.5">{formatDate(o.createdAt)}</div>
              <div className="text-xs text-brand-600 mt-1">{statusLabel[o.status] ?? o.status}</div>
            </div>
            <div className="text-right">
              <div className="font-semibold">{formatRub(o.total)}</div>
              <div className="text-xs text-slate-400">{o.items.length} поз.</div>
            </div>
          </Link>
        ))}
        {data?.length === 0 && (
          <div className="text-center text-slate-400 py-8">Заказов ещё нет</div>
        )}
      </div>
    </div>
  );
}
